// extracted by mini-css-extract-plugin
module.exports = {"fotorama__active":"_02712f2b3b--fotorama__active--M9mYW","mvk-fotorama-spinner":"_02712f2b3b--mvk-fotorama-spinner--qtxgD"};